import { render, staticRenderFns } from "./red-error-triangle.vue?vue&type=template&id=4a7b513a&functional=true"
import script from "./red-error-triangle.vue?vue&type=script&lang=js"
export * from "./red-error-triangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports